import { getUserMail } from "../../services/util/getUserMail";
import { axiosBuySell, axiosUSD } from "../axios";


let userObj:any = {'email_id' : getUserMail()}
export function getStartEndDateIF(months:any, asset:any, type:any){
    return axiosUSD.post(`/intraday/get_startDate_endDate`,{"month": months, "asset":asset, "type":type,"username": userObj?.email_id})
    .then((res:any)=>{
        return res;
    }).catch((e:any)=>console.log("ERROR:", e)
    
    )
}
export function getHistoricalPlPercentageIF(startDate:any, endDate:any,assetType:string,version:any, filterDropdownVersion:any)
{
     return axiosBuySell.post(`/intraday/get_pl_percent`,{"startDate":startDate,
        "endDate":endDate,
        "asset":assetType,
        "version":version,
        "username": userObj?.email_id,
        "filterDropdownVersion":filterDropdownVersion
    })
        .then((res:any) => {
            return res.data;
        }).catch((err:any) => console.log(err))
}
export function getHistoricalCallsIF(startDate:any, endDate:any,assetType:string, version:any, filterDropdownVersion:any)
{
     return axiosBuySell.post(`/intraday/get_calls`,{ "startDate":startDate,
                                                    "endDate":endDate,
                                                    "asset":assetType,
                                                    "version":version,
                                                    "username": userObj?.email_id,
                                                    "filterDropdownVersion":filterDropdownVersion}).then((res) => {
                                                        return res.data;
                                                    }).catch((err) => console.log(err))
}
export function getHistoricalSRIF(startDate:any, endDate:any,assetType:string,version:any, filterDropdownVersion:any)
{
     return axiosBuySell.post(`/intraday/get_sr`,{
                    "startDate":startDate,
                    "endDate":endDate,
                    "asset":assetType,
                    "version":version,
                    "username": userObj?.email_id,
                    "filterDropdownVersion":filterDropdownVersion})
        .then((res:any) => {
            return res.data;
        }).catch((err:any) => console.log(err))
}
export function getHistoricalPlIF(startDate:any, endDate:any,assetType:string, version:string, filterDropdownVersion:any)
{
     return axiosBuySell.post(`/intraday/get_pl`,{"startDate":startDate,
     "endDate":endDate,
     "asset":assetType,
     "version":version,
     "username": userObj?.email_id,
     "filterDropdownVersion":filterDropdownVersion })
        .then((res:any) => {
            return res.data;
        }).catch((err:any) => console.log(err))
}
export function getHistoricalTradesIF(startDate: any, endDate:any,assetType:string,version:any, filterDropdownVersion:any)
{
     return axiosBuySell.post(`/intraday/get_trades`,{
        "asset":assetType,
        "startDate":startDate,
        "endDate":endDate,
        "version": version,
        "username": userObj?.email_id,
        "filterDropdownVersion":filterDropdownVersion
    })
        .then((res:any) => {
            return res.data;
        }).catch((err:any) => console.log(err))
}
export function getHistoricalParameterIF(id:any,asset:any,version:any,date:any)
{
    return axiosUSD.post(`/intraday/get_parameter`,{"asset":asset,"version":version,"date":date,"id":id,"username": userObj?.email_id})
        .then((res:any)=>{
            return res.data
        }).catch((err:any)=>console.log(err))
}
export function getHistoricalTargetSlIF(id:any,asset:any,date:any,version:any)
{
    return axiosBuySell.post(`/intraday/get_target_stoploss`,
    {
        "id":id,
        "asset":asset,
        "date":date,
        "version":version
        // "username": userObj?.email_id
    })
            .then((res:any) => {
                return res.data;
        }).catch((err:any) => console.log(err))
}
export function getHistoricalMtmDrawdownIF(id:any,asset:any,date:any,version:any)
{
    return axiosBuySell.post(`/intraday/get_m2m_drawdown`,{

        "id":id,
        "asset":asset,
        "date":date,
        "version": version
    })
            .then((res:any) => {
                return res.data;
        }).catch((err:any) => console.log(err))
}
